import { Fallback } from 'platform/remix-run/react';

export default function DashboardIndex(): RouteComponentOutput {
  return <Fallback to="sell" />;
}
